// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainer":"BaseSnackbar_snackbarContainer__2tMPI","snackbarIcon":"BaseSnackbar_snackbarIcon__2tvd2","success":"BaseSnackbar_success__2SRnA"};